import React, { createContext, useContext } from 'react';
const Context = createContext(undefined);
export const useLocalStorageKey = () => useContext(Context);
export default function withLocalStorageKeyContext(Provider) {
    return function ReactKeycloakProvider(props) {
        const { authClient, localStorageKey = 'keycloak_tokens', ...other } = props;
        return (React.createElement(Context.Provider, { value: localStorageKey },
            React.createElement(Provider, { authClient: authClient, ...other })));
    };
}
//# sourceMappingURL=withLocalStorageKeyContext.js.map